import { history } from 'services/history.js'

import themeCss from '../components/sass/theme.module.scss'
// ItemEndedCard was copied from AuctionEndedCard, refactored for copy related to item page
import css from '../auctions/sass/auctions.module.scss'
import auctionCardCss from '../auctions/sass/auctionscards.module.scss'
import { calculateUserBalance } from '../util/endedAuctionUtils'

export default function ItemEndedCard({ auction, auctionUser, route }) {

  const outstandingBalance = calculateUserBalance(auctionUser, auction)
  const amountDue = outstandingBalance.total

  const proceedToCheckout = () => {
    if (route !== 'auction') localStorage.setItem('myItems', true)
    
    history.push({
      pathname: '/checkout',
      search: `?auctionId=${auction.AuctionCode}`,
    })
  }

  if (amountDue === 0) return

  return(

    <div className={themeCss['box-top-yellow-accent-wide']} >
      <p className={auctionCardCss['auction-box-info-heading']}>The auction has ended, thank you for participating!</p>
      <p className={auctionCardCss['auction-box-info-text-smaller']}>You have items and/or donations ready for check out. Please click below to complete your checkout.</p>
      <button onClick ={() => proceedToCheckout()} className={`${themeCss['FilledYellow']} ${themeCss['button']} ${css['button-to-checkout']}`}>
        Proceed to Checkout
      </button>
    </div>
  )
}